import { createSlice } from "@reduxjs/toolkit";

import { getCategoryList, addCategoryList, updateCategoryList, deleteCategoryList } from "./thunk";

export const initialState = {
    categoryList: {
        content: []
    },
    errors: {}
};

const CategorySlice = createSlice({
    name: 'Category',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(getCategoryList.fulfilled, (state: any, action: any) => {
            state.categoryList = action.payload;
        });
        builder.addCase(getCategoryList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(addCategoryList.fulfilled, (state: any, action: any) => {
            console.log(action.payload)
            state.categoryList.content.unshift(action.payload);
        });

        builder.addCase(addCategoryList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(updateCategoryList.fulfilled, (state: any, action: any) => {
            state.categoryList.content = state.categoryList.content.map((category: any) =>
                category.id === action.payload.id
                    ? { ...category, ...action.payload }
                    : category
            );
        });

        builder.addCase(updateCategoryList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(deleteCategoryList.fulfilled, (state: any, action: any) => {
            state.categoryList.content = state.categoryList.content.filter(
                (categoryList: any) => categoryList.id !== action.payload
            );
            console.log(action.payload)
        });
        builder.addCase(deleteCategoryList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default CategorySlice.reducer;